import type { FC } from 'react'

type Props = {
  className?: string
}

const QuestionOutlined: FC<Props> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor" // Use currentColor to inherit from parent
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2596_75601)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.45734 4.34664C7.87995 4.29238 7.19888 4.40492 6.60299 4.66847C6.26627 4.8174 5.87257 4.66516 5.72364 4.32843C5.57471 3.9917 5.72696 3.598 6.06368 3.44908C6.85379 3.09963 7.76272 2.94216 8.58208 3.01916C9.38521 3.09462 10.2321 3.41375 10.6935 4.16032C11.5591 5.56113 10.863 7.06601 9.69626 8.05306C9.197 8.47545 8.94989 8.77019 8.82137 9.0007C8.70517 9.20913 8.66667 9.39869 8.66667 9.66677C8.66667 10.035 8.36819 10.3334 8 10.3334C7.63181 10.3334 7.33334 10.035 7.33334 9.66677C7.33334 9.23485 7.40268 8.80724 7.6568 8.35143C7.89862 7.91769 8.28434 7.50109 8.83508 7.03515C9.76839 6.24554 9.9196 5.44442 9.55921 4.86122C9.40755 4.61579 9.05097 4.40242 8.45734 4.34664Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_2596_75601">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default QuestionOutlined
